/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 2/16/16.
 */

'use strict';

function configRoutes(
    $injector,
    $locationProvider,
    $routeProvider
) {
    $locationProvider.html5Mode(true);

    $routeProvider
        .when('/login', {
            template: '<login></login>',
            publicAccess: true
        })


        //===========//
        // Dashboard //
        //===========//

        .when('/dashboard/queues/summary', {
            templateUrl: 'dashboard/queues/queues-view-template.html',
            label: 'Queues Summary',
            showRefreshOnly: true
        })
        .when('/dashboard/workflows', {
            templateUrl: 'dashboard/workflows/searchView/workflows-view-template.html',
            label: 'Workflow Execution Progress',
            reloadOnSearch: false,
            searchEnabled: true,
            filterEnabled: true
        })
        .when('/dashboard/workflows/:id/steps', {
            templateUrl: 'dashboard/workflows/stepView/workflow-step-view-template.html',
            controller: 'WorkflowStepViewController as workflowStepViewCntrlr',
            rootRoute: '/dashboard/workflows',
            resolve: {
                parentWorkflow: ['WorkflowExecutionResourceFactory', '$route',
                    function (WorkflowExecutionResourceFactory, $route) {
                        return WorkflowExecutionResourceFactory.getWorkflowExecution({
                            id: $route.current.params.id
                        }).$promise;
                    }]
            },
            reloadOnSearch: false,
            searchEnabled: true
        })
        .when('/dashboard/queues/summary/:group', {
            templateUrl: 'dashboard/queues/groupSummary/queues-group-summary-view-template.html',
            controller: 'QueuesGroupSummaryViewController as queueGroupSummaryCtrlr',
            rootRoute: '/dashboard/queues/summary',
            showRefreshOnly: true
        })
        .when('/dashboard/queues/summary/:group/:id/steps', {
            template: '<queue-detail-view></queue-detail-view>',
            rootRoute: '/dashboard/queues/summary',
            reloadOnSearch: false,
            searchEnabled: true
        })
        .when('/dashboard/report/:reportName', {
            template: '<report-view></report-view>',
            searchEnabled: false
        })
        .when('/dashboard/calendars', {
            templateUrl: 'dashboard/calendars/searchView/calendars-view-template.html',
            controller: 'CalendarsViewController as calCtrl',
            label: 'calendars',
            reloadOnSearch: false,
            searchEnabled: true,
        })
        .when('/dashboard/offCyclePlanners', {
            template: '<off-cycle-planners-view></off-cycle-planners-view>',
            label: 'Planners / Avails / Feeds',
            reloadOnSearch: false,
            searchEnabled: true
        })
        .when('/dashboard/checkin', {
            template: '<package-checkin></package-checkin>',
            label: 'Package Check-in',
            reloadOnSearch: false,
            searchEnabled: false,
        })
        .when('/dashboard/metrics', {
            label: 'Metrics',
            publicAccess: true,
            reloadOnSearch: false,
            rootRoute: '/dashboard/metrics',
            searchEnabled: false,
            template: '<metrics-dashboard></metrics-dashboard>'
        })


        //======//
        // Meta //
        //======//

        // Networks
        .when('/meta/networks/search', {
            template: '<network-search-view></network-search-view>',
            label: 'Networks',
            searchEnabled: true
        })
        .when('/meta/networks/edit/:id', {
            template: '<network-edit-view></network-edit-view>',
            label: 'Networks',
            reloadOnSearch: false
        })
        .when('/meta/networks/edit/:id/ratingOverlays/edit/:acceptProfileId', {
            template: '<branding-media-edit-view branding-config="$resolve.brandingConfig"></branding-media-edit-view>',
            resolve: {
                brandingConfig: ['$route',
                    function ($route) {
                        return {
                            parentLocation: '/meta/networks/edit/' + $route.current.params.id,
                            id: $route.current.params.id,
                            type: 'ratingOverlays',
                            isShow: false,
                            groupName: 'networks'
                        };
                    }]
            },
            rootRoute: '/meta/networks/search',
            reloadOnSearch: false
        })
        .when('/meta/networks/edit/:id/:type/edit/:containerId', {
            template: '<branding-container-edit-view branding-config="$resolve.brandingConfig"></branding-container-edit-view>',
            resolve: {
                brandingConfig: ['$route',
                    function ($route) {
                        return {
                            parentLocation: '/meta/networks/edit/' + $route.current.params.id,
                            id: $route.current.params.containerId,
                            type: $route.current.params.type,
                            isShow: false,
                            groupName: 'networks'
                        };
                    }]
            },
            rootRoute: '/meta/networks/search',
            reloadOnSearch: false
        })
        .when('/meta/networks/edit/:id/:type/edit/:containerId/acceptProfiles/edit/:acceptProfileId', {
            template: '<branding-media-edit-view branding-config="$resolve.brandingConfig"></branding-media-edit-view>',
            resolve: {
                brandingConfig: ['$route',
                    function ($route) {
                        return {
                            parentLocation: '/meta/networks/edit/' + $route.current.params.id,
                            id: $route.current.params.containerId,
                            type: $route.current.params.type,
                            isShow: false,
                            groupName: 'networks'
                        };
                    }]
            },
            rootRoute: '/meta/networks/search',
            reloadOnSearch: false
        })

        // Ads & PreRolls
        .when('/meta/adsAndPreRolls/search', {
            template: `<content-search-view content-type="'Ad/PreRoll'"></content-search-view-view>`,
            label: 'AdsAndPreRolls',
            searchEnabled: true
        })
        .when('/meta/adsAndPreRolls/edit/:id/:editView', {
            template: `<content-edit-view content-type="'Ad/PreRoll'" is-season="false"></content-edit-view>`,
            label: 'AdsAndPreRolls',
            rootRoute: '/meta/adsAndPreRolls/search',
            reloadOnSearch: false
        })
        .when('/meta/adsAndPreRolls/edit/:id/categories/edit/:contentCategoryId', {
            template: `<content-categories-edit-view content-type="'Ad/PreRoll'"></content-categories-edit-view>`,
            label: 'Series',
            rootRoute: '/meta/adsAndPreRolls/edit/:id/categories',
            reloadOnSearch: false
        })

        // Series
        .when('/meta/series/search', {
            template: `<content-search-view content-type="'Series'"></content-search-view-view>`,
            label: 'Series',
            searchEnabled: true
        })
        .when('/meta/series/edit/:id/:editView', {
            template: `<content-edit-view content-type="'Series'" is-season="false"></content-edit-view>`,
            label: 'Series',
            rootRoute: '/meta/series/search',
            reloadOnSearch: false
        })
        .when('/meta/series/edit/:id/actor/edit/:actorId', {
            template: '<actor-edit-view content-name="$resolve.contentName" is-series="true"></actor-edit-view>',
            resolve: {
                contentName: ['$route', 'ContentResourceFactory',
                    ($route, ContentResourceFactory) => {
                        return ContentResourceFactory.get({id: $route.current.params.id}).$promise.then((content) => {
                            return content.name;
                        });
                    }]
            },
            label: 'Series',
            rootRoute: '/meta/series/search',
            reloadOnSearch: false
        })
        .when('/meta/series/edit/:id/categories/edit/:contentCategoryId', {
            template: `<content-categories-edit-view content-type="'Series'"></content-categories-edit-view>`,
            label: 'Series',
            rootRoute: '/meta/series/edit/:id/categories',
            reloadOnSearch: false
        })
        .when('/meta/series/edit/:id/seasons/edit/:seasonId/:editView', {
            template: '<content-season-volume-editor content="$resolve.content" season="$resolve.season"></content-season-volume-editor>',
            label: 'Series',
            rootRoute: '/meta/series/edit/:id/seasons',
            reloadOnSearch: false,
            resolve: {
                content: ['$route', 'ContentResourceFactory',
                    ($route, ContentResourceFactory) => {
                        return ContentResourceFactory.get({id: $route.current.params.id}).$promise;
                    }],
                season: ['$route', 'ContentResourceFactory',
                    ($route, ContentResourceFactory) => {
                        if ($route.current.params.seasonId !== '-1') {
                            return ContentResourceFactory.getSeason({id: $route.current.params.seasonId}).$promise;
                        } else {
                            return undefined;
                        }
                    }]
            },
        })
        .when('/meta/series/edit/:id/volumes/edit/:volumeId/:editView', {
            template: '<content-season-volume-editor></content-season-volume-editor>',
            label: 'Series',
            rootRoute: '/meta/series/edit/:id/volumes',
            reloadOnSearch: false,
        })
        .when('/meta/series/edit/:id/:type/edit/:containerId', {
            template: '<branding-container-edit-view branding-config="$resolve.brandingConfig"></branding-container-edit-view>',
            resolve: {
                brandingConfig: ['$route',
                    function ($route) {
                        return {
                            parentLocation: '/meta/series/edit/' + $route.current.params.id + '/' + $route.current.params.type,
                            id: $route.current.params.containerId,
                            type: $route.current.params.type,
                            isShow: true,
                            groupName: 'series'
                        };
                    }]
            },
            rootRoute: '/meta/series/search',
            reloadOnSearch: false
        })
        .when('/meta/series/edit/:id/seasons/edit/:seasonId/:type/edit/:containerId', {
            template: '<branding-container-edit-view branding-config="$resolve.brandingConfig"></branding-container-edit-view>',
            resolve: {
                brandingConfig: ['$route', function ($route) {
                    return {
                        parentLocation: '/meta/series/edit/' + $route.current.params.id + '/seasons/edit/' + $route.current.params.seasonId + '/' + $route.current.params.type,
                        id: $route.current.params.containerId,
                        seasonId: $route.current.params.seasonId,
                        type: $route.current.params.type,
                        isShow: true,
                        groupName: 'series'
                    };
                }]
            },
            rootRoute: '/meta/series/search',
            reloadOnSearch: false,
        })
        .when('/meta/series/edit/:id/volumes/edit/:volumeId/:type/edit/:containerId', {
            template: '<branding-container-edit-view branding-config="$resolve.brandingConfig"></branding-container-edit-view>',
            resolve: {
                brandingConfig: ['$route', function ($route) {
                    return {
                        parentLocation: '/meta/series/edit/' + $route.current.params.id + '/volumes/edit/' + $route.current.params.volumeId + '/' + $route.current.params.type,
                        id: $route.current.params.containerId,
                        volumeId: $route.current.params.volumeId,
                        type: $route.current.params.type,
                        isShow: true,
                        groupName: 'series'
                    };
                }]
            },
            rootRoute: '/meta/series/search',
            reloadOnSearch: false,
        })
        .when('/meta/series/edit/:id/:type/edit/:containerId/acceptProfiles/edit/:acceptProfileId', {
            template: '<branding-media-edit-view branding-config="$resolve.brandingConfig"></branding-media-edit-view>',
            resolve: {
                brandingConfig: ['$route',
                    function ($route) {
                        return {
                            parentLocation: '/meta/series/edit/' + $route.current.params.id + '/' + $route.current.params.type,
                            id: $route.current.params.containerId,
                            type: $route.current.params.type,
                            isShow: true,
                            groupName: 'series'
                        };
                    }]
            },
            rootRoute: '/meta/series/search',
            reloadOnSearch: false
        })
        .when('/meta/series/edit/:id/seasons/edit/:seasonId/:type/edit/:containerId/acceptProfiles/edit/:acceptProfileId', {
            template: '<branding-media-edit-view branding-config="$resolve.brandingConfig"></branding-media-edit-view>',
            resolve: {
                brandingConfig: ['$route', function ($route) {
                    return {
                        parentLocation: '/meta/series/edit/' + $route.current.params.id + '/seasons/edit/' + $route.current.params.seasonId + '/' + $route.current.params.type,
                        id: $route.current.params.containerId,
                        seasonId: $route.current.params.seasonId,
                        type: $route.current.params.type,
                        isShow: true,
                        groupName: 'series'
                    };
                }]
            },
            rootRoute: '/meta/series/search',
            reloadOnSearch: false,
        })
        .when('/meta/series/edit/:id/volumes/edit/:volumeId/:type/edit/:containerId/acceptProfiles/edit/:acceptProfileId', {
            template: '<branding-media-edit-view branding-config="$resolve.brandingConfig"></branding-media-edit-view>',
            resolve: {
                brandingConfig: ['$route', function ($route) {
                    return {
                        parentLocation: '/meta/series/edit/' + $route.current.params.id + '/volumes/edit/' + $route.current.params.volumeId + '/' + $route.current.params.type,
                        id: $route.current.params.containerId,
                        volumeId: $route.current.params.volumeId,
                        type: $route.current.params.type,
                        isShow: true,
                        groupName: 'series'
                    };
                }]
            },
            rootRoute: '/meta/series/search',
            reloadOnSearch: false,
        })

        // Movies
        .when('/meta/movies/search', {
            template: `<content-search-view content-type="'Movie/Special'"></content-search-view-view>`,
            label: 'Movies/Specials',
            searchEnabled: true
        })
        .when('/meta/movies/edit/:id/:editView', {
            template: `<content-edit-view content-type="'Movie/Special'"></content-edit-view>`,
            label: 'Movies/Specials',
            rootRoute: '/meta/movies/search',
            reloadOnSearch: false
        })
        .when('/meta/movies/edit/:id/actor/edit/:actorId', {
            template: '<actor-edit-view content-name="$resolve.contentName" is-series="false"></actor-edit-view>',
            resolve: {
                contentName: ['$route', 'ContentResourceFactory',
                    ($route, ContentResourceFactory) => {
                        return ContentResourceFactory.get({id: $route.current.params.id}).$promise.then((content) => {
                            return content.name;
                        });
                    }]
            },
            label: 'Movies/Specials',
            rootRoute: '/meta/movies/search',
            reloadOnSearch: false
        })
        .when('/meta/movies/edit/:id/categories/edit/:contentCategoryId', {
            template: `<content-categories-edit-view content-type="'Movie/Special'"></content-categories-edit-view>`,
            label: 'Movies/Specials',
            rootRoute: '/meta/movies/edit/:id/categories',
            reloadOnSearch: false
        })
        .when('/meta/movies/edit/:id/:type/edit/:containerId', {
            template: '<branding-container-edit-view branding-config="$resolve.brandingConfig"></branding-container-edit-view>',
            resolve: {
                brandingConfig: ['$route',
                    function ($route) {
                        return {
                            parentLocation: '/meta/movies/edit/' + $route.current.params.id + '/' + $route.current.params.type,
                            id: $route.current.params.containerId,
                            type: $route.current.params.type,
                            isShow: true,
                            groupName: 'movies'
                        };
                    }]
            },
            rootRoute: '/meta/movies/search',
            reloadOnSearch: false
        })
        .when('/meta/movies/edit/:id/:type/edit/:containerId/acceptProfiles/edit/:acceptProfileId', {
            template: '<branding-media-edit-view branding-config="$resolve.brandingConfig"></branding-media-edit-view>',
            resolve: {
                brandingConfig: ['$route',
                    function ($route) {
                        return {
                            parentLocation: '/meta/movies/edit/' + $route.current.params.id + '/' + $route.current.params.type,
                            id: $route.current.params.containerId,
                            type: $route.current.params.type,
                            isShow: true,
                            groupName: 'movies'
                        };
                    }]
            },
            rootRoute: '/meta/movies/search',
            reloadOnSearch: false
        })

        // Collaborators
        .when('/meta/collaborators/search', {
            template: '<collaborators-grid-search-view></collaborators-grid-search-view>',
            label: 'Collaborators',
            searchEnabled: true
        })
        .when('/meta/collaborators/edit/:id', {
            template: '<collaborators-edit-view></collaborators-edit-view>',
            label: 'Collaborators',
            reloadOnSearch: false,
            rootRoute: '/meta/collaborators/search'
        })

        // MVPD Setup
        .when('/meta/mvpd/search', {
            template: '<mvpd-grid-search-view></mvpd-grid-search-view>',
            label: 'MVPD Setup',
            searchEnabled: true
        })
        .when('/meta/mvpd/edit/partner/:id/:groupName', {
            template: `<mvpd-partner-grid-search-view mvpd-config="$resolve.mvpdConfig"></mvpd-partner-grid-search-view>`,
            resolve: {
                mvpdConfig: ['$route', 'PartnerResourceFactory',
                    ($route, PartnerResourceFactory) => {
                        return PartnerResourceFactory.get({id: $route.current.params.id}).$promise.then((partner) => {
                            return {partnerName: partner.name};
                        });
                    }]
            },
            rootRoute: '/meta/mvpd/search',
            searchEnabled: true,
            reloadOnSearch: false
        })
        .when('/meta/mvpd/edit/partner/:id/:groupName/:groupId/metadata/:view', {
            template: `<mvpd-metadata-item-edit-view mvpd-config="$resolve.mvpdConfig"></mvpd-metadata-item-edit-view>`,
            resolve: {
                mvpdConfig: ['$route', 'PartnerResourceFactory',
                    ($route, PartnerResourceFactory) => {
                        let mvpdConfig = {
                            parentLocation: `/meta/mvpd/edit/partner/${$route.current.params.id}/${$route.current.params.groupName}`
                        };

                        return PartnerResourceFactory.get({id: $route.current.params.id}).$promise.then((partner) => {
                            mvpdConfig.partnerName = partner.name;
                            return mvpdConfig;
                        });
                    }]
            },
            rootRoute: '/meta/mvpd/search',
            searchEnabled: false
        })
        .when('/meta/mvpd/edit/partner/:id/:groupName/:groupId/metadata/:view/:seasonVolumeId/edit/:subView', {
            template: `<mvpd-metadata-item-edit-view mvpd-config="$resolve.mvpdConfig"></mvpd-metadata-item-edit-view>`,
            resolve: {
                mvpdConfig: ['$route', 'PartnerResourceFactory',
                    ($route, PartnerResourceFactory) => {
                        let mvpdConfig = {
                            parentLocation: `/meta/mvpd/edit/partner/${$route.current.params.id}/${$route.current.params.groupName}/${$route.current.params.groupId}/metadata/${$route.current.params.view}`
                        };

                        return PartnerResourceFactory.get({id: $route.current.params.id}).$promise.then((partner) => {
                            mvpdConfig.partnerName = partner.name;
                            return mvpdConfig;
                        });
                    }]
            },
            rootRoute: '/meta/mvpd/search',
            searchEnabled: false
        })


        //========//
        // System //
        //========//

        // Partners
        .when('/system/partners/search', {
            templateUrl: 'system/partner/partner-template.html',
            label: 'Partners',
            searchEnabled: true
        })
        .when('/system/partners/edit/:id/:editView', {
            template: '<partner-edit-view></partner-edit-view>',
            rootRoute: '/system/partners/search',
            reloadOnSearch: false,
            searchEnabled: true,
            filterEnabled: true
        })
        .when('/system/partners/edit/:id/deliveryendpoints/:endpointType/edit/:endpointId', {
            template: '<partner-delivery-endpoints-editor></partner-delivery-endpoints-editor>',
            rootRoute: '/system/partners/edit/:id/:editView',
            reloadOnSearch: false
        })
        .when('/system/partners/edit/:id/emailendpoints/edit/:endpointId', {
            template: '<partner-email-endpoints-editor></partner-email-endpoints-editor>',
            rootRoute: '/system/partners/edit/:id/:editView',
            reloadOnSearch: false
        })
        .when('/system/partners/edit/:id/planner/edit/:plannerId', {
            template: '<partner-planner-editor></partner-planner-editor>',
            rootRoute: '/system/partners/edit/:id/:editView',
            reloadOnSearch: false
        })
        .when('/system/partners/edit/:id/dueDateTemplates/edit/:dueDateTemplateId', {
            template: '<partner-due-date-templates-editor></partner-due-date-templates-editor>',
            rootRoute: '/system/partners/edit/:id/:editView',
            reloadOnSearch: false
        })

        .when('/system/partners/edit/:id/nielsenTemplates/edit/:nielsenTemplateId', {
            template: '<nielsen-templates-edit-view></nielsen-templates-edit-view>',
            rootRoute: '/system/partners/edit/:id/:editView',
            reloadOnSearch: false
        })

        .when('/system/partners/edit/:id/deliveryProfiles/edit/:deliveryProfileId', {
            template: '<delivery-profiles-edit-view partner-name="$resolve.partnerName"></delivery-profiles-edit-view>',
            resolve: {
                partnerName: ['$route', 'PartnerResourceFactory',
                    ($route, PartnerResourceFactory) => {
                        return PartnerResourceFactory.get({id: $route.current.params.id}).$promise.then((partner) => {
                            return partner.name;
                        });
                    }],
            }
        })

        .when('/system/partners/edit/:id/deliveryProfiles/edit/:deliveryProfileId/emails/edit/:deliveryEmailId', {
            template: '<delivery-email-edit-view></delivery-email-edit-view>'
        })

        .when('/system/partners/edit/:id/deliveryProfiles/edit/:deliveryProfileId/deliveryItems/edit/:mediaAcceptProfileId', {
            template: '<delivery-profiles-delivery-items-edit-view  resolve-data="$resolve.resolveData"></delivery-profiles-delivery-items-edit-view>',
            resolve: {
                resolveData: ['$route', 'PartnerResourceFactory', 'MediaAcceptProfileService', '$q',
                    ($route, PartnerResourceFactory, MediaAcceptProfileService, $q) => {
                        return $q.all({
                            partner: PartnerResourceFactory.get({id: $route.current.params.id}).$promise,
                            mediaAcceptProfile: MediaAcceptProfileService.getAcceptProfile($route.current.params.mediaAcceptProfileId),
                        }).then((data) => {
                            return {
                                partnerName: data.partner.name,
                                mediaAcceptProfile: data.mediaAcceptProfile,
                            };
                        });
                    }]
            }
        })

        .when('/system/partners/edit/:id/deliveryProfiles/edit/:deliveryProfileId/deliveryItems/edit/:mediaAcceptProfileId/:deliveryItemType/edit/:deliveryItemId', {
            template: '<delivery-item-edit-view resolve-data="$resolve.resolveData"></delivery-item-edit-view>',
            resolve: {
                resolveData: ['$route', 'PartnerResourceFactory', 'MediaAcceptProfileService', 'PartnerEditService', '$q',
                    ($route, PartnerResourceFactory, MediaAcceptProfileService, PartnerEditService, $q) => {
                        return $q.all({
                            partner: PartnerResourceFactory.get({id: $route.current.params.id}).$promise,
                            mediaAcceptProfile: MediaAcceptProfileService.getAcceptProfile($route.current.params.mediaAcceptProfileId),
                            deliveryProfile: PartnerEditService.getDeliveryProfile($route.current.params.deliveryProfileId)
                        }).then((data) => {
                            return {
                                partnerName: data.partner.name,
                                mediaAcceptProfile: data.mediaAcceptProfile,
                                deliveryProfilePackageAcceptTemplateId: data.deliveryProfile.packageAcceptTemplate.id
                            };
                        });
                    }]
            }
        })

        // Users
        .when('/system/users/search', {
            template: '<users-search-view></users-search-view>',
            label: 'Users',
            searchEnabled: true
        })
        .when('/system/users/edit/:id', {
            template: '<users-edit-view></users-edit-view>',
            rootRoute: '/system/users/search'
        })

        // Groups
        .when('/system/groups/search', {
            template: '<groups-search-view></groups-search-view>',
            label: 'Groups',
            searchEnabled: true
        })
        .when('/system/groups/edit/:id', {
            template: '<group-edit-view></group-edit-view>',
            rootRoute: '/system/groups/search'
        })

        // Contacts
        .when('/system/contacts/search', {
            template: '<contacts-search-view></contacts-search-view>',
            label: 'Contacts',
            searchEnabled: true
        })
        .when('/system/contacts/edit/:contactId', {
            template: '<contacts-edit-view></contacts-edit-view>',
            rootRoute: '/system/contacts/search'
        })

        // Properties
        .when('/system/properties/search', {
            template: '<properties-search-view></properties-search-view>',
            label: 'Properties',
            searchEnabled: true,
            reloadOnSearch: false
        })

        // Dynamic Properties
        .when('/system/properties/dynamicProperty/edit', {
            template: '<dynamic-props-edit-view></dynamic-props-edit-view>',
            reloadOnSearch: true
        })

        // Roles
        .when('/system/properties/roles/edit/:id', {
            template: '<roles-edit-view></roles-edit-view>',
        })

        // Roles
        .when('/system/properties/roles/edit/:id/:type', {
            template: '<roles-edit-view></roles-edit-view>',
        })

        // Categories
        .when('/system/properties/categories/edit/:id', {
            template: '<categories-edit-view></categories-edit-view>',
        })

        // Languages
        .when('/system/properties/languages/edit/:id', {
            template: '<languages-edit-view></languages-edit-view>',
        })

        // Genres
        .when('/system/properties/genres/edit/:id', {
            template: '<genres-edit-view></genres-edit-view>',
        })

        // Territories
        .when('/system/properties/territories/edit/:id', {
            template: '<territories-edit-view></territories-edit-view>',
        })

        // Metadata Items
        .when('/system/metadataItems/:type', {
            template: '<metadata-items-search-view></metadata-items-search-view>',
            label: 'Metadata Items',
            reloadOnSearch: false
        })

        // Live Feeds
        .when('/system/livefeeds/search', {
            templateUrl: 'system/livefeed/livefeed-template.html',
            label: 'Live Feeds',
            reloadOnSearch: false,
            searchEnabled: true
        })
        .when('/system/livefeeds/edit/:id', {
            templateUrl: 'system/livefeed/editor/livefeed-edit-template.html',
            controller: 'LiveFeedEditController as liveFeedEditCtrl',
            rootRoute: '/system/livefeeds/search',
            reloadOnSearch: false
        })

        // File Systems
        .when('/system/fileSystems/search', {
            template: '<file-system-search-view></file-system-search-view>',
            label: 'File Systems',
            searchEnabled: true,
            reloadOnSearch: false
        })
        .when('/system/fileSystems/edit/:id/:editView', {
            template: '<file-system-edit-view></file-system-edit-view>',
            searchEnabled: true,
            reloadOnSearch: false
        })
        .when('/system/fileSystems/edit/:id/directories/edit/:directoryId', {
            template: '<directory-edit-view></directory-edit-view>'
        })

        // Templates
        .when('/system/templates/search', {
            template: '<templates-search-view></templates-search-view>',
            label: 'Templates',
            searchEnabled: true,
            reloadOnSearch: false
        })

        // Delivery Templates
        .when('/system/templates/deliveryTemplates/edit/:id', {
            template: '<delivery-templates-edit-view></delivery-templates-edit-view>',
        })

        // Email Templates
        .when('/system/templates/emailTemplates/edit/:id', {
            template: '<email-templates-edit-view></email-templates-edit-view>',
        })

        // Hybrik Templates

        .when('/system/templates/hybrikTemplates/edit/:id', {
            template: '<hybrik-template-edit-view></hybrik-template-edit-view>',

        })

        // FFmpeg Templates

        .when('/system/templates/ffmpegTemplates/edit/:id', {
            template: '<ffmpeg-templates-edit-view></ffmpeg-templates-edit-view>',

        })

        // Intermediate Templates
        .when('/system/templates/intermediateTemplates/edit/:id', {
            template: '<intermediate-templates-edit-view></intermediate-templates-edit-view>',
        })

        // Conditional Templates
        .when('/system/templates/conditionalTemplates/edit/:id', {
            template: '<conditional-templates-edit-view></conditional-templates-edit-view>',
        })

        // Transform Templates
        .when('/system/templates/transformTemplates/edit/:id', {
            template: '<transform-templates-edit-view></transform-templates-edit-view>',
        })

        // Image Templates
        .when('/system/templates/imageTemplates/edit/:id', {
            template: '<image-templates-edit-view></image-templates-edit-view>',
        })
        // Image Templates
        .when('/system/templates/packageCreationTemplates/edit/:id', {
            template: '<package-creation-templates-edit-view></package-creation-templates-edit-view>',
        })

        // MacCaption Templates
        .when('/system/templates/macCaptionTemplates/edit/:id', {
            template: '<mac-caption-templates-edit-view></maccaption-templates-edit-view>',
        })


        // Media Accept Profiles
        .when('/system/templates/media/acceptProfiles/edit/:id', {
            template: '<media-accept-profiles-edit-view></media-accept-profiles-edit-view>',
            reloadOnSearch: false
        })

        // Media Accept Profile Video Validator Edit
        .when('/system/templates/media/acceptProfiles/edit/:id/videoValidators/edit/:validatorId', {
            template: '<media-accept-profiles-video-validator-edit-view accept-profile="$resolve.acceptProfile"></media-accept-profiles-video-validator-edit-view>',
            reloadOnSearch: false,
            resolve: {
                acceptProfile: ['$route', 'MediaAcceptProfileService',
                    ($route, MediaAcceptProfileService) => {
                        return MediaAcceptProfileService.getAcceptProfile($route.current.params.id);
                    }]
            }
        })

        // Media Accept Profile Audio Validator Edit
        .when('/system/templates/media/acceptProfiles/edit/:id/audioValidators/edit/:validatorId', {
            template: '<media-accept-profiles-audio-validator-edit-view accept-profile="$resolve.acceptProfile"></media-accept-profiles-audio-validator-edit-view>',
            reloadOnSearch: false,
            resolve: {
                acceptProfile: ['$route', 'MediaAcceptProfileService',
                    ($route, MediaAcceptProfileService) => {
                        return MediaAcceptProfileService.getAcceptProfile($route.current.params.id);
                    }]
            }
        })
        // Media Accept Profile Artwork Validator Edit
        .when('/system/templates/media/acceptProfiles/edit/:id/artworkValidators/edit/:validatorId', {
            template: '<media-accept-profiles-image-validator-edit-view accept-profile="$resolve.acceptProfile"></media-accept-profiles-image-validator-edit-view>',
            reloadOnSearch: false,
            resolve: {
                acceptProfile: ['$route', 'MediaAcceptProfileService',
                    ($route, MediaAcceptProfileService) => {
                        return MediaAcceptProfileService.getAcceptProfile($route.current.params.id);
                    }]
            }
        })

        // Media Accept Profile Image Validator Edit
        .when('/system/templates/media/acceptProfiles/edit/:id/imageValidators/edit/:validatorId', {
            template: '<media-accept-profiles-image-validator-edit-view accept-profile="$resolve.acceptProfile"></media-accept-profiles-image-validator-edit-view>',
            reloadOnSearch: false,
            resolve: {
                acceptProfile: ['$route', 'MediaAcceptProfileService',
                    ($route, MediaAcceptProfileService) => {
                        return MediaAcceptProfileService.getAcceptProfile($route.current.params.id);
                    }]
            }
        })

        // Package Accept Profiles
        .when('/system/templates/media/packageAcceptTemplates/edit/:id', {
            template: '<package-accept-templates-edit-view></package-accept-templates-edit-view>',
        })

        // External Ingest
        .when('/system/aggregation/:view', {
            template: '<external-metadata></external-metadata>',
            reloadOnSearch: false
        })
        .when('/system/aggregation/edit/:id/:externalIngestType?', {
            template: '<external-metadata-edit-view xsl-templates="$resolve.xslTemplates"></external-metadata-edit-view>',
            resolve: {
                xslTemplates: ['TransformTemplatesResourceFactory',
                    function (TransformTemplatesResourceFactory) {
                        return TransformTemplatesResourceFactory.query().$promise;
                    }]
            }
        })

        // Exec Servers
        .when('/system/execServers', {
            templateUrl: 'system/execServers/exec-servers-template.html',
            reloadOnSearch: false,
            searchEnabled: true
        })

        // Package Notifications
        .when('/system/packageNotifications/search', {
            template: '<package-notifications-search-view></package-notifications-search-view>',
            label: 'Package Notifications',
            reloadOnSearch: false
        })
        .when('/system/packageNotifications/edit/:notificationId', {
            template: '<package-notifications-edit-view></package-notifications-edit-view>',
            rootRoute: '/system/packageNotifications/search',
            reloadOnSearch: false
        })

        //
        // PACKAGES
        //

        .when('/packages', {
            templateUrl: 'package/package-template.html',
            label: 'Packages - Edit',
            reloadOnSearch: false,
            searchEnabled: true,
            filterEnabled: true
        })
        .when('/packages/package/edit/:id/:editView', {
            templateUrl: 'package/editor/package-edit-template.html',
            controller: 'PackageEditController as pkgEditCtrl',
            rootRoute: '/packages',
            reloadOnSearch: false,
            searchEnabled: false
        })
        .otherwise({
            redirectTo: function () {
                return '/login';
            }
        });
}

angular.module('prism-ui').config(configRoutes);
